export default __webpack_public_path__ + "static/media/stop.9fd4423a.svg";